import {css} from 'lit';
export const styles = css`:host {
  --background: var(--gray-100);
  --type-margin: 0 8px 0 0;
  --type-padding: 10px 14px;
  --type-background: var(--gray-100);
  --type-border-radius: 6px;
  --type-icon-size: 30px;
  --title-font-weight: 600;
  --title-font-size: var(--font-size-sm, 14px);
  --size-font-size: var(--font-size-xs, 12px);

  display: inline-block;
  max-width: 260px;
}

.type {
  margin: var(--type-margin);
  padding: var(--type-padding);
  background-color: var(--type-background);
  border-radius: var(--type-border-radius);
}

.type > ef-icon {
    font-size: var(--type-icon-size);
  }

.type span {
    display: inline-block;
    padding: 2px 4px;
    border-radius: 4px;
    background-color: var(--file-type-file);
    font-size: 11px;
    color: #fff;
    text-transform: uppercase;
  }

.type.type-image span {
    background-color: var(--file-type-image);
  }

.type.type-video span {
    background-color: var(--file-type-video);
  }

.type.type-audio span {
    background-color: var(--file-type-audio);
  }

.type.type-pdf span {
    background-color: var(--file-type-pdf);
  }

.type.type-doc span {
    background-color: var(--file-type-doc);
  }

.type.type-sheet span {
    background-color: var(--file-type-sheet);
  }

.type.type-slide span {
    background-color: var(--file-type-slide);
  }

.type.type-archive span {
    background-color: var(--file-type-archive);
  }

.title {
  display: flex;
  font-size: var(--title-font-size);
  font-weight: var(--title-font-weight);
  white-space: nowrap;
}

.title span:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
  }

.size {
  font-size: var(--size-font-size);
}

:host([layout='lg']) {
  --background: var(--gray-100);
  --type-margin: 8px 24px 8px 0;
  --type-padding: 0 8px;
  --type-background: transparent;
  --type-border-radius: 0;
  --type-icon-size: 30px;
  --title-font-weight: 400;
  --title-font-size: var(--font-size-xs, 12px);
  --size-font-size: calc(var(--font-size-xs, 12px) - 1px);
}

:host([layout='lg']) a {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    min-width: 1px;
    padding: 0 8px;
    border: 1px solid var(--border-light);
    border-radius: 4px;
    background-color: var(--background);
    color: var(--dark-text);
    overflow: hidden;
    transition: border ease-in-out 0.2s;
  }

:host([layout='lg']) a .title {
      justify-content: start;
    }

@media (hover: hover) {
      :host([layout='lg']) a:hover {
        border-color: var(--primary-500);
      }
    }

@media (min-width: 400px) {

:host([layout='lg']) a {
      display: block;
      padding: 0;
      background-color: #fff;
      text-align: center
  }

      :host([layout='lg']) a .title {
        justify-content: center;
      }
    }

:host([layout='lg']) .type {
    position: relative;
  }

:host([layout='lg']) .type span {
      position: absolute;
      right: -16px;
      bottom: -4px;
    }

@media (min-width: 400px) {

:host([layout='lg']) .type {
      margin-right: 0
  }

      :host([layout='lg']) .type span {
        position: relative;
        right: auto;
        right: initial;
        bottom: auto;
        bottom: initial;
        margin-left: -16px;
      }
    }

:host([layout='lg']) .info {
    width: 100%;
    overflow: hidden;
    transition: background-color ease-in-out 0.2s;
  }

@media (min-width: 400px) {

:host([layout='lg']) .info {
      padding: 8px;
      border-top: 1px solid var(--border-light-secondary);
      background-color: var(--background)
  }
    }

:host([layout='lg']) .size {
    color: var(--dark-text-secondary);
  }

:host([layout='sm']) {
  --background: var(--gray-100);
  --type-margin: 0;
  --type-padding: 0;
  --type-background: transparent;
  --type-border-radius: 0;
  --type-icon-size: inherit;
  --title-font-weight: 400;
  --title-font-size: var(--font-size-xs, 12px);
}

:host([layout='sm']) a {
    display: flex;
    align-items: center;
    min-width: 1px;
    min-height: 32px;
    padding: 4px 8px;
    border: 1px solid var(--border-light-secondary);
    border-radius: 4px;
    background-color: #fff;
    color: var(--dark-text);
    font-size: 12px;
  }

@media (hover: hover) {
      :host([layout='sm']) a:hover {
        background-color: var(--gray-200);
      }
    }

:host([layout='sm']) a:active {
      background-color: var(--gray-300);
    }

:host([layout='sm']) .type > span {
    margin-right: 8px;
  }

:host([layout='sm']) .info {
    width: 100%;
    overflow: hidden;
  }

:host([layout='md']) a {
    display: flex;
    align-items: center;
    color: var(--dark-text);
    transition: opacity var(--transition-duration) var(--transition-timing);
  }

@media (hover: hover) {
      :host([layout='md']) a:hover {
        opacity: 0.7;
      }
    }

:host([layout='md']) a:active {
      opacity: 0.9;
    }

:host([layout='md']) .type > span {
    display: none;
  }

:host([layout='md']) .info {
    background-color: transparent;
    text-align: left;
    border: none;
    overflow: hidden;
    text-overflow: ellipsis;
  }

:host([layout='md']) .title {
    justify-content: flex-start;
  }
`;
export default styles;
